"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllowedEMs = getAllowedEMs;
const mf_finder_1 = require("mf-finder");
async function getAllowedEMs(options) {
    const { ranges, masses, precision, ionizations } = options;
    if (!ranges)
        return;
    const allowedEMs = [];
    for (let mass of masses) {
        const { mfs } = await (0, mf_finder_1.findMFs)(mass, {
            ionizations,
            precision,
            ranges,
            limit: 100000,
        });
        for (const mf of mfs) {
            allowedEMs.push(mf.em);
        }
    }
    return Float64Array.from(allowedEMs).toSorted();
}
//# sourceMappingURL=getAllowedEMs.js.map